export default __webpack_public_path__ + "static/media/19.6e0c3345.jpg";